import { render, staticRenderFns } from "./DashModal.vue?vue&type=template&id=7087f989&scoped=true"
import script from "./DashModal.vue?vue&type=script&lang=js"
export * from "./DashModal.vue?vue&type=script&lang=js"
import style0 from "./DashModal.vue?vue&type=style&index=0&id=7087f989&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7087f989",
  null
  
)

export default component.exports